/**
 * appOperationBtnsModule
 * description: app渠道下操作按钮
 * author: Qian.qianchen 2019-03-21
 */
'use strict';
angular.module('baijiahaoOperationBtnsModule', []).directive('baijiahaoOperationBtns', ['modalDialog', 'trsHttpService', 'newMediaService', function(modalDialog, trsHttpService, newMediaService) {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: './editingCenter/iWo/fusionPending/directive/baijiahaoOperationBtns/baijiahaoOperationBtns_tpl.html',
        scope: {
            productInfo: '=',
            selectedArr: '=',
            callback: '&'
        },
        link: function($scope, iElement, attrs) {
            initStatus();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus () {
                $scope.newOperationParams = {
                    serviceid: 'mlf_fusion',
                    methodname: 'doActionOnMediaTypeAndDocIdsSync',
                    oprType: 'daibian',
                    actionKey: '',
                    // mediaTypeDocIds: [],
                    // OprTime: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    // OprTimeStart: '',
                    // OprTimeEnd: '',
                };
                $scope.status = {
                    signedSuccess: false
                };
                $scope.data = {
                    trench: 'Fusion',
                    filterArray: []
                };
                $scope.requestData = $scope.callback;
            }

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function dealOperParams() {
                $scope.newOperationParams.mediaTypeDocIds = [];
                $scope.selectedArr.forEach((item) => {
                    $scope.newOperationParams.mediaTypeDocIds.push({
                        MEDIATYPE: item.MEDIATYPE,
                        DOCID: item.METADATAID
                    });
                });
                $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
            }

            /**
             * [trialForBaijiahao description] 百家号送审
             * @return {[type]} [description]
             */
            $scope.trialForBaijiahao = function() {
                $scope.newOperationParams.actionKey = 'songshen';
                $scope.data.selectedArray = $scope.selectedArr;
                $scope.loadingPromise = newMediaService.trial($scope, $scope.newOperationParams);
            };

            /**
             * [signedForBaijiahao description] 百家号签发
             * @return  {[type]}  [return description]
             */
            $scope.signedForBaijiahao = function() {
                modalDialog.confirmModal('签发', '确认签发?', function() {
                    dealOperParams();
                    $scope.newOperationParams.actionKey = 'qianfa';
                    $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then(function(data) {
                        if (angular.isArray(data.REPORTS)) {
                            modalDialog.multiReportsAlert(data, function() {
                                $scope.callback();
                            });
                        } else {
                            modalDialog.alertType('', data.DETAIL, 'warning', 'confirm');
                        }
                    }, function (data) {
                        $scope.callback();
                    });
                });
            };
        }
    };
}]);
